import axios from 'axios';
import {
    GET_INTERVAL_TYPES, INTERVAL_ERROR
} from './types';

import { base_url } from './constants';

axios.defaults.baseURL = base_url;

//GET Intervals
export const getIntervals = () => async dispatch => {
    try {
        const res = await axios.get('/api/intervals_types/');
        console.log(res.data);
        dispatch({ type: GET_INTERVAL_TYPES, payload: res.data })
    } catch (err) {
        dispatch({
            type: INTERVAL_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });
    }
}
